import { COMPANY } from './config.js';
const BASE = import.meta.env?.VITE_PUSH_ORIGIN || 'https://vendeypro.cenfelec.com';
export async function notifyEvent(event, session, details = {}) {
  const response = await fetch(BASE + '/api/eventos/' + event, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: AbortSignal.timeout(4000),
    body: JSON.stringify({ codigoEmpresa: COMPANY, codigoAlmacen: String(session.warehouseId), nombreAlmacen: session.store, usuario: session.seller, ...details })
  });
  if (!response.ok) throw new Error(`No se pudo notificar (${response.status}).`);
  return response.json();
}
